"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SearchAction;
(function (SearchAction) {
    SearchAction.ON_SEARCH_SET_UPDATED = 'ON_SEARCH_SET_UPDATED';
    SearchAction.CHECK_SERACH_ID_UPDATE = 'CHECK_SERACH_ID_UPDATE';
    SearchAction.CLEAR_TEXT_IMAGES = 'CLEAR_TEXT_IMAGES';
    SearchAction.USE_SEARCH_QUERY = 'USE_SEARCH_QUERY';
    SearchAction.onSearchSetUpdated = typesafe_actions_1.createAction(SearchAction.ON_SEARCH_SET_UPDATED, function (resolve) { return function (searchSet) { return resolve(searchSet); }; });
    SearchAction.checkSearchIdUpdate = typesafe_actions_1.createAction(SearchAction.CHECK_SERACH_ID_UPDATE, function (resolve) { return function () { return resolve(); }; });
    SearchAction.clearTextImages = typesafe_actions_1.createAction(SearchAction.CLEAR_TEXT_IMAGES, function (resolve) { return function () { return resolve(); }; });
    SearchAction.useSearchQuery = typesafe_actions_1.createAction(SearchAction.USE_SEARCH_QUERY, function (resolve) { return function (searchQuery) { return resolve(searchQuery); }; });
})(SearchAction || (SearchAction = {}));
exports.default = SearchAction;
